export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7812.b7d322d6.jpg";